import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, DatePicker, Row, Col, Drawer, Divider, InputNumber } from 'antd';
import moment from 'moment';
import { _newLine } from '@/utils/helpers';
import BaseSelect from '@/components/Elements/BaseSelect';
import CKEditorComponent from '@/components/Editor/CKEditorComponent'
import { isMobile } from 'react-device-detect';
import DocumentFileUpload from '@/routes/documents/DocumentFileUpload';
import {
    createProjectJob,
    updateProjectJob
} from '@/redux/actions/projectJobActions';
import { getActiveProjects } from '@/redux/actions/projectActions';

class ProjectJobForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isloading: false,
            attachedFiles: [],
            fileResetKey: 0
        };
    }

    componentDidUpdate(prevProps) {
        const opened = this.props.visible && !prevProps.visible;
        const changedItem = this.props.visible && prevProps.currentData?.id !== this.props.currentData?.id;
        if (opened || changedItem) {
            this.props.getActiveProjects();
            this.setState({
                attachedFiles: this.props.currentData?.attached_files || [],
                fileResetKey: this.state.fileResetKey + 1
            });
        }
    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    this.setState({ isloading: true })
                    const params = {
                        name: values.name,
                        project_id: values.project_id,
                        sort_order: values.sort_order,
                        user_id: values.user_id ? parseInt(values.user_id, 10) : null,
                        description: values.description,
                        note: values.note,
                        start_date: values.start_date ? values.start_date.format("YYYY-MM-DD") : null,
                        deadline: values.deadline ? values.deadline.format("YYYY-MM-DD") : null,
                        attached_files: this.state.attachedFiles
                    }
                    if (this.props.currentData) {
                        await this.props.updateProjectJob(this.props.currentData.id, params);
                        this.handCancel()
                        this.props.reloadData()
                    } else {
                        await this.props.createProjectJob(params);
                        this.handCancel()
                        this.props.reloadData()
                    }
                    //console.log(params)
                    this.setState({ isloading: false })
                } catch (error) {
                    this.setState({ isloading: false });
                }
            }
        });
    }

    handCancel() {
        this.props.form.resetFields();
        this.props.onCancel();
        this.setState({
            isloading: false,
            attachedFiles: [],
            fileResetKey: this.state.fileResetKey + 1
        })
    }

    render() {
        const { isloading, attachedFiles, fileResetKey } = this.state;
        var { visible, currentData, users, project_active_list } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <Drawer
                visible={visible}
                title={currentData ? "Sửa công việc" : "Thêm mới công việc"}
                onOk={(e) => this.submit(e)}
                onClose={() => this.handCancel()}
                maskClosable={false}
                width={isMobile ? '100%' : '60%'}
                footer={
                    <div style={{ textAlign: 'right' }}>
                        <Button key="back" onClick={() => this.handCancel()}>
                            Huỷ
                        </Button>
                        <Divider type='vertical' />
                        <Button loading={isloading} key="submit" type="primary" onClick={(e) => this.submit(e)}>
                            {currentData ? "Cập nhật" : "Tạo"}
                        </Button>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <Form.Item label="Tên công việc">
                                    {getFieldDecorator("name", {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentData ? currentData.name : null
                                    })(
                                        <Input />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Dự án">
                                    {getFieldDecorator('project_id', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Vui lòng chọn dự án.'
                                            }
                                        ],
                                        initialValue: currentData ? currentData.project_id : null
                                    })(
                                        <BaseSelect
                                            options={project_active_list || []}
                                            optionValue="id"
                                            optionLabel="name"
                                            defaultText="Chọn dự án"
                                            showSearch={true}
                                            style={{ width: '100%' }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="STT">
                                    {getFieldDecorator("sort_order", {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentData ? currentData.sort_order : null
                                    })(
                                        <InputNumber className='w-100' step={1} min={1} />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Người thực hiện">
                                    {getFieldDecorator('user_id', {
                                        rules: [
                                            {
                                                required: false,
                                                message: 'Vui lòng chọn người thực hiện.'
                                            }
                                        ],
                                        initialValue: currentData ? currentData.user_id : null
                                    })(
                                        <BaseSelect
                                            options={users}
                                            optionValue="user_id"
                                            optionLabel="display_name"
                                            defaultText="Chọn người thực hiện"
                                            showSearch={true}
                                            style={{ width: '100%' }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Ngày bắt đầu">
                                    {getFieldDecorator("start_date", {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentData ? moment(currentData.start_date).isValid() ? moment(currentData.start_date) : null : ''
                                    })(
                                        <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                                <Form.Item label="Deadline">
                                    {getFieldDecorator("deadline", {
                                        rules: [
                                            {
                                                validator: (_, value, callback) => {
                                                    const startDate = this.props.form.getFieldValue('start_date');
                                                    if (value && startDate && value.isBefore(startDate, 'day')) {
                                                        callback('Deadline không được trước ngày bắt đầu.');
                                                    } else {
                                                        callback();
                                                    }
                                                }
                                            },
                                        ],
                                        initialValue: currentData ? moment(currentData.deadline).isValid() ? moment(currentData.deadline) : null : ''
                                    })(
                                        <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Form.Item label="Tệp đính kèm">
                            <DocumentFileUpload
                                resetKey={`project-job-${currentData?.id || 'new'}-${fileResetKey}`}
                                value={attachedFiles}
                                onChange={files => this.setState({ attachedFiles: files })}
                            />
                        </Form.Item>
                        <Form.Item label="Mô tả công việc">
                            {getFieldDecorator('description', {
                                rules: [
                                    {
                                        required: true,
                                        message: "Vui lòng chọn!",
                                    },
                                ],
                                initialValue: currentData ? currentData.description : null
                            })(
                                <CKEditorComponent
                                    initialHeight="300px"
                                    editorData={currentData?.description}
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="Ghi chú">
                            {getFieldDecorator('note', {
                                rules: [
                                    {
                                        required: false,
                                        message: "Vui lòng chọn!",
                                    },
                                ],
                                initialValue: currentData ? _newLine(currentData.note) : ''
                            })(
                                <Input.TextArea rows={4} />
                            )}
                        </Form.Item>


                    </Form>
                    : null
                }
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {
        users: state.config.users,
        authUser: state.auth.authUser,
        project_active_list: state.projectReducer.project_active_list
    }
}

function mapDispatchToProps(dispatch) {
    return {
        createProjectJob: data => dispatch(createProjectJob(data)),
        updateProjectJob: (id, data) => dispatch(updateProjectJob(id, data)),
        getActiveProjects: filter => dispatch(getActiveProjects(filter))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'ProjectJobForm' })(ProjectJobForm));
